import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../../theme';
import { borderRadius } from '../../styles/mixins';
import { FA_SELECTOR } from '../../styles/variables';

// Reused both as its own rendered class (ReportsDateRange/ReportsDownloadSummary/
// ReportsSelectionSection) and spread into ReportsDialog.styles.js's `toolbar`
// key — reports-feature-specific, no owner outside this directory.
export const reportsDialogSection = token => ({
  padding: ThemeSpaces.SPACE_NORM_20,
  backgroundColor: ThemeColors.COLOR_WHITE2_5,
  border: `1px solid ${token.colorWhite}`,
  borderRadius: ThemeBorderRadius.BORDER_RADIUS_BASE,
  boxShadow: `1px 1px 20px ${ThemeColors.COLOR_GREY_BLUISH4_1}`,
});

export const useReportsSharedStyles = createStyles(({ token }) => ({
  reportsSectionContent: {
    ...reportsDialogSection(token),
    display: 'flex',
    flexDirection: 'column',
    gap: ThemeSpaces.SPACE_NORM,
    margin: `${ThemeSpaces.SPACE_NORM_15}px 0`,

    [`@media (min-width: ${token.screenLGMin}px)`]: {
      minHeight: 480,
      maxHeight: 560,
    },
    [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
      {
        minHeight: 300,
        maxHeight: 360,
      },
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      minHeight: 240,
      maxHeight: 300,
    },
  },

  // `&& .InlineLink` outranks SimpleDialog.styles.js's generic `.InlineLink`
  // color rule (equal specificity otherwise).
  reportsSectionTitle: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: ThemeSpaces.SPACE_NORM,
    borderTop: `1px solid ${token.colorWhite}`,
    borderBottom: `1px solid ${ThemeColors.COLOR_GREY7_8}`,

    'h3.ant-typography': {
      fontFamily: ThemeFont.FONT_FAMILY6,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      margin: 0,
    },

    '&& .InlineLink': {
      color: token.colorPrimary,
      fontSize: token.fontSizeSM,
      textTransform: 'uppercase',

      '&.disabled': {
        opacity: 0.35,
      },
    },

    '.InputSearchFlat': {
      height: '24px !important',
      borderRadius: `${token.borderRadiusLG}px !important`,
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      width: 276,
    },
  },

  selectionSection: {
    borderRadius: token.borderRadiusSM,
    border: `1px solid ${ThemeColors.COLOR_GREY7_8}`,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: ThemeSpaces.SPACE_NORM,
    flex: 1,

    '.ant-row': {
      width: '100%',
    },
  },

  selectionSectionTitle: {
    height: 40,
    lineHeight: 1,
    padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
    display: 'flex',
    alignItems: 'center',
    fontFamily: ThemeFont.FONT_FAMILY6,
    fontSize: ThemeFont.FONT_SIZE_30,
    textTransform: 'uppercase',
    color: token.colorWhite,
    backgroundColor: ThemeColors.COLOR_GREY_BLUISH7_2,
    ...borderRadius({ size: token.borderRadiusSM, side: 'top' }),

    '.ant-col': {
      fontFamily: ThemeFont.FONT_FAMILY6,
      fontSize: ThemeFont.FONT_SIZE_30,
    },

    [FA_SELECTOR]: {
      color: ThemeColors.COLOR_GREY_BLUISH,
    },
  },

  selectionSectionBody: {
    padding: `${ThemeSpaces.SPACE_XS}px ${ThemeSpaces.SPACE_NORM_20}px 0 ${ThemeSpaces.SPACE_NORM_20}px`,
    display: 'flex',
    flexDirection: 'column',
    gap: ThemeSpaces.SPACE_NORM,
  },

  selectionTag: {
    '&&': {
      backgroundColor: token.colorPrimary,
      color: token.colorWhite,
      borderRadius: token.borderRadiusLG,
      fontFamily: token.fontFamily,
      fontWeight: 500,
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    },
  },
}));
